/** Parâmetros de URL que carregam segredos (redefinição de senha, verificação de e-mail, OAuth). */
const SECRET_PARAMS = /([?&](?:token|code|key|secret|password)=)[^&#]*/gi

/** Troca o valor dos parâmetros secretos por [removido], preservando o resto da URL. */
export function scrubUrl(url: string): string {
  return url.replace(SECRET_PARAMS, "$1[removido]")
}
